import { cn } from '@/lib/utils';
import heroPhone from '../assets/hero-phone.webp';
import usersIcon from '../assets/icon-users.svg';
import { useLiveClaims, formatClaims } from '../hooks/use-live-claims';

interface CheckoutHeroProps {
  onCta: () => void;
}

export function CheckoutHero({ onCta }: CheckoutHeroProps) {
  const claims = useLiveClaims();

  return (
    <section className="flex flex-col items-center px-4 pb-6 pt-6">
      <h1 className="text-center font-display text-[28px] font-bold leading-9 text-mf-neutral-900">
        Your Money <span className="text-mf-green">Could Be Ready Today</span>
      </h1>
      <p className="mt-2 text-center text-base leading-5 text-mf-neutral-600">
        Stop leaving money on the table. We find settlements and refunds you&apos;re owed — and file
        the claim for you.
      </p>

      <img
        src={heroPhone}
        alt=""
        className="mt-6 h-[361px] w-full max-w-[361px] object-contain object-top"
      />

      <button
        type="button"
        onClick={onCta}
        className="mt-6 flex h-[52px] w-full items-center justify-center rounded-full bg-mf-neutral-900 text-base font-bold text-white transition-opacity hover:opacity-90"
      >
        Track & save
      </button>

      <ClaimsTicker amount={claims} className="mt-4" />
    </section>
  );
}

export function ClaimsTicker({
  amount,
  className,
}: {
  amount: number;
  className?: string;
}) {
  return (
    <p
      className={cn(
        'flex items-center justify-center gap-1 text-sm leading-4 text-mf-neutral-400',
        className,
      )}
    >
      <img src={usersIcon} alt="" className="size-4 shrink-0" />
      <span>
        Users filed <span className="font-bold text-mf-green">{formatClaims(amount)}</span> in claims
        today
      </span>
    </p>
  );
}
